import { render, staticRenderFns } from "./NewPolicyPrompt.vue?vue&type=template&id=2b0acfda"
import script from "./NewPolicyPrompt.vue?vue&type=script&lang=js"
export * from "./NewPolicyPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports